import db from "../Db";
import { GetAllAgendaTache } from "./AgendaTache";

var _ = require("lodash");

export function GetAllDefunt() {
  return new Promise(function (resolve, reject) {
    if (!db.isOpen()) {
      db.open();
    }

    db.DEFUNT.toArray().then((result) => {
      return resolve(_.orderBy(result, ["ETAT_CIVIL.NOMDEF", "ETAT_CIVIL.PRENOMDEF"], "asc"));
    });
  });
}

export function GetAllDefuntInTask() {
  return new Promise(function (resolve, reject) {
    if (!db.isOpen()) {
      db.open();
    }

    GetAllAgendaTache().then((tache) => {
      let D0CLEUNIK = [];

      _.forEach(tache, (t) => {
        if (t.D0CLEUNIK > 0) {
          D0CLEUNIK.push(t.D0CLEUNIK);
        }
      });

      db.DEFUNT.where("D0CLEUNIK")
        .anyOf(D0CLEUNIK)
        .toArray()
        .then((result) => {
          return resolve(_.orderBy(result, ["ETAT_CIVIL.NOMDEF", "ETAT_CIVIL.PRENOMDEF"], "asc"));
        });
    });
  });
}

export function GetDefuntById(D0CLEUNIK) {
  return new Promise(function (resolve, reject) {
    if (!db.isOpen()) {
      db.open();
    }

    db.DEFUNT.where("D0CLEUNIK")
      .equals(parseInt(D0CLEUNIK))
      .first()
      .then((result) => {
        return resolve(result);
      });
  });
}

export function GetDefuntByLicleunik(LICLEUNIK) {
  return new Promise(function (resolve, reject) {
    if (!db.isOpen()) {
      db.open();
    }

    db.DEFUNT.where("LICLEUNIK")
      .equals(parseInt(LICLEUNIK))
      .toArray()
      .then((result) => {
        return resolve(result);
      });
  });
}

export function GetDefuntsRecherche(TYPECIME,NOMDEF,PRENOMDEF,DATEDEBUT,DATEFIN) {
  return new Promise(function (resolve, reject) {
    if (!db.isOpen()) {
      db.open();
    }

    let query = db.DEFUNT.toCollection();
    
    if (TYPECIME) {
      query = query.filter((d) => d.TYPECIME === TYPECIME);
    }

    if (NOMDEF) {
      const nomLower = NOMDEF.toLowerCase();
      query = query.filter((d) => {
        return d.ETAT_CIVIL && d.ETAT_CIVIL.NOMDEF &&
               d.ETAT_CIVIL.NOMDEF.toLowerCase().includes(nomLower);
      });
    }

    if (PRENOMDEF) {
      const prenomLower = PRENOMDEF.toLowerCase();
      query = query.filter((d) => {
        return d.ETAT_CIVIL && d.ETAT_CIVIL.PRENOMDEF &&
               d.ETAT_CIVIL.PRENOMDEF.toLowerCase().includes(prenomLower);
      });
    }

    if(DATEDEBUT){
       query = query.filter((d) => {
        return d.ETAT_CIVIL && d.ETAT_CIVIL.DATEDECES &&
               d.ETAT_CIVIL.DATEDECES > DATEDEBUT;
      });
    }

    
    if(DATEFIN){
       query = query.filter((d) => {
        return d.ETAT_CIVIL && d.ETAT_CIVIL.DATEDECES &&
               d.ETAT_CIVIL.DATEDECES < DATEFIN;
      });
    }

    query.toArray()
      .then((result) => resolve(result))
      .catch((err) => reject(err));
  });
}

export function GetDefuntByIdTablette(ID) {
  return new Promise(function (resolve, reject) {
    if (!db.isOpen()) {
      db.open();
    }

    db.DEFUNT.get(parseInt(ID)).then((result) => {
      return resolve(result);
    });
  });
}

export function GetDefuntByCocleunik(COCLEUNIK) {
  return new Promise(function (resolve, reject) {
    if (!db.isOpen()) {
      db.open();
    }

    db.DEFUNT.where("COCLEUNIK")
      .equals(COCLEUNIK)
      .toArray()
      .then((result) => {
        return resolve(result);
      });
  });
}

export function GetDefuntInCendre() {
  return new Promise(function (resolve, reject) {
    if (!db.isOpen()) {
      db.open();
    }

    db.DEFUNT.where("NUMCENDRE")
      .notEqual(0)
      .toArray()
      .then((result) => {
        return resolve(result);
      });
  });
}

export function GetDefuntByNumcendre(NUMCENDRE) {
  return new Promise(function (resolve, reject) {
    if (!db.isOpen()) {
      db.open();
    }

    db.DEFUNT.where("NUMCENDRE")
      .equals(parseInt(NUMCENDRE))
      .toArray()
      .then((result) => {
        return resolve(result);
      });
  });
}
